import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Apikey, ApikeyData } from '../../../shared/interfaces/apikey.interfaces';

export const ApikeyActions = createActionGroup({
  source: 'Apikey',
  events: {
    'Load Apikeys': emptyProps(),
    'Load Apikeys Success': props<{ data: ApikeyData[] }>(),

    'Create Apikey': props<{ name: string }>(),
    'Create Apikey Success': props<{ data: Apikey }>(),

    'Revoke Apikey': props<{ id: number }>(),
    'Revoke Apikey Success': props<{ data: any }>(),

    'Unset Apikey Store': emptyProps(),
  }
});
